@if (!isLoading) {
<div class="card" [class.has-error]="showValidation">
  <div class="card-header">Verification Checklist</div>
  <div class="card-body">
    <ul class="list-group list-group-flush">
      @for (item of applicableItems; track item.id) {
      <li class="list-group-item ps-2">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [id]="item.id" [checked]="item.isChecked"
            (change)="toggle(item)" />
          <label class="form-check-label" [attr.for]="item.id">{{ item.label }}</label>
        </div>
      </li>
      }
    </ul>
    @if (showValidation) {
    <div class="text-danger mt-2">Every item must be checked before this task can be completed.</div>
    }
  </div>
</div>
}
